import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpStrategyService, LanguageService, UserReportStateService } from 'ats-ui-lib';
import { CustomEncoder } from './custom-encoder';
import { environment } from '../../../environments/environment';

@Injectable()
export class AtsInterceptor implements HttpInterceptor {
  private recruitmentApiEndpoint = environment.recruitmentApiEndpoint;

  private applicantApiEndpoint = environment.applicantApiEndpoint;

  private parserApiEndpoint = environment.parserApiEndpoint;

  private metricsApiEndpoint = environment.metricsApiEndpoint;

  constructor(
    private languageService: LanguageService,
    private httpStrategyService: HttpStrategyService,
    private userReportStateService: UserReportStateService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isFromAtsBackend(req)) {
      req = this.addCustomEncoder(req);
      req = this.setCustomHeaders(req);
      req = this.httpStrategyService.transform(req);
    }
    const nextResult = next.handle(req);
    return this.userReportStateService.interceptHttpErrors(req, nextResult);
  }

  private isFromAtsBackend(req: HttpRequest<any>): boolean {
    return (
      req.url.includes(this.recruitmentApiEndpoint) ||
      req.url.includes(this.applicantApiEndpoint) ||
      req.url.includes(this.parserApiEndpoint) ||
      req.url.includes(this.metricsApiEndpoint)
    );
  }

  private addCustomEncoder(req: HttpRequest<any>): HttpRequest<any> {
    const params = new HttpParams({
      encoder: new CustomEncoder(),
      fromString: req.params.toString(),
    });
    return req.clone({ params });
  }

  private setCustomHeaders(req: HttpRequest<any>): HttpRequest<any> {
    const headers: Record<string, string> = {
      'X-ATS-Offset': this.getTimezoneOffset(),
      'Accept-Language': this.languageService.getAcceptLanguageHeader(),
    };
    return req.clone({
      setHeaders: headers,
    });
  }

  private getTimezoneOffset(): string {
    const offset = new Date().getTimezoneOffset();
    const offsetExpected = -offset;
    return offsetExpected.toString();
  }
}
